<template>
  <div class="page-view-report">
    <div class="panel-info-section">
      <div class="panel-info-section-title flex items-center">
        <a-icon type="caret-right" class="text-primary v-mr-xs" />
        <span class="text-bold">项目进展报告</span>
        <a-button-group size="small" class="v-ml-auto">
          <a-button @click="tab = 1" :type="tab == 1 ? 'primary' : 'default'">全部项目报告</a-button>
          <a-button @click="tab = 2" :type="tab == 2 ? 'primary' : 'default'">精选照片</a-button>
        </a-button-group>
      </div>
      <a-table key="table-edit" class="list-table" size="small" rowKey="reportId" :loading="recordsLoading" :pagination="false" :data-source="records" :scroll="{ x: '100%' }">
        <a-table-column title="#" data-index="index" :width="60" align="center">
          <template slot-scope="text, record, index">
            {{ index + 1 }}
          </template>
        </a-table-column>
        <a-table-column title="报告类型" data-index="type" align="left">
          <template slot-scope="text, record">
            <a-tag color="#f24a78" v-if="record.type == 2101">监理报告</a-tag>
            <a-tag color="#f24a78" v-else-if="record.type == 2102">甲醛检测报告</a-tag>
            <a-tag color="#f24a78" v-else-if="record.type == 2103">签署收到房屋的签署单</a-tag>
            <a-tag color="#f24a78" v-else-if="record.type == 2104">入住仪式</a-tag>
            <a-tag color="#3f51b5" v-else-if="record.type == 2105">项目设计图</a-tag>
            <a-tag color="#3f51b5" v-else-if="record.type == 2106">改造前照片</a-tag>
            <a-tag color="#3f51b5" v-else-if="record.type == 2107">改造中照片</a-tag>
            <a-tag color="#3f51b5" v-else-if="record.type == 2108">改造后照片</a-tag>
            <a-tag color="#3f51b5" v-else-if="record.type == 2109">项目改造报告</a-tag>
            <a-tag color="#3f51b5" v-else-if="record.type == 2110">财务报告</a-tag>
          </template>
        </a-table-column>
        <a-table-column title="报告文件" data-index="files" align="left">
          <template slot-scope="text, record">
            <file-container :img-size="[100, 55]" :files="record.files" :belongId="projectId" fileSign="P01" v-if="record.files && projectId"></file-container>
          </template>
        </a-table-column>
        <a-table-column title="提交时间" :width="130" data-index="createTime" align="left">
          <template slot-scope="text, record">
            <template v-if="record.state === 0">{{ record.createTime ? record.createTime.substring(0, 16) : '' }}</template>
            <template v-else>{{ record.submitTime ? record.submitTime.substring(0, 16) : '' }}</template>
          </template>
        </a-table-column>
        <a-table-column title="报告提交人" data-index="creatorName" :width="160" :ellipsis="true" align="left" />
        <a-table-column title="状态" data-index="quantity" :width="100" align="left">
          <template slot-scope="text, record">
            <span class="text-red" v-if="record.state == 0">待提交</span>
            <span v-else-if="record.state == 9">审核通过</span>
            <span class="text-red" v-else>待审核</span><span class="text-red" v-if="record.checkResult == -1">(驳回)</span>
          </template>
        </a-table-column>
        <a-table-column title="操作" data-index="amount" :width="80" align="center">
          <template slot-scope="text, record">
            <a-space :size="10">
              <span class="font-xs hover-line text-indigo" title="处理" @click="$router.push(`../report/review?id=${projectId}&rid=${record.reportId}`)" v-if="isProcessable(record.state)">处理</span>
              <template v-else-if="record.state === 0 && record.origin == 1">
                <span class="font-xs hover-line text-indigo" title="修改" @click="$router.push(`../report/draft?id=${projectId}&rid=${record.reportId}`)">修改</span>
                <span class="font-xs hover-line text-red" title="删除" @click="handleDel(record.reportId)">删除</span>
              </template>
              <span class="font-xs hover-line text-indigo" title="查看" @click="$router.push(`../report/detail?id=${projectId}&rid=${record.reportId}`)" v-else>查看</span>
            </a-space>
          </template>
        </a-table-column>
      </a-table>
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
        <div class="list-pagination v-ml-auto">
          <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
        </div>
      </div>
    </div>
    <!-- 报告详情 -->
    <a-drawer
      title="报告详情"
      placement="right"
      destroy-on-close
      :closable="false"
      :width="700"
      :get-container="pageContainer"
      :wrap-style="{ position: 'absolute' }"
      :body-style="{ padding: '16px 16px 60px', height: 'calc(100% - 44px)', overflowY: 'auto' }"
      :visible="showRecord"
      @close="onDrawerClose"
    >
      <!-- <report check :id="recordId" @close="onDrawerClose" @handle="onRecordHandle" /> -->
    </a-drawer>
  </div>
</template>

<script>
import { listReport, delReport } from '@/api/project/common'
export default {
  name: 'ProjectReportList',
  data() {
    return {
      projectId: null,
      records: [],
      recordsLoading: false,
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      tab: 1,
      showRecord: false,
      recordId: undefined,
    }
  },
  computed: {
    project: vm => vm.$store.state.app.project,
  },
  watch: {
    tab() {
      this.loadRecords()
    },
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        this.loadRecords()
      }
    },
    loadRecords(page = 1, pageSize = 10, sorter) {
      this.recordsLoading = true
      let params = {
        projectId: this.projectId,
        page,
        pageSize,
        sorter,
        origin: 1,
      }
      let { tab } = this
      if (tab == 2) {
        params.state = 9
        params.isChosen = 1
      }
      listReport(params).then(({ data }) => {
        if (data.success) {
          let { current, size, total, records } = data.result
          records.forEach(item => {
            if (item.medias) {
              item.files = (tab == 2 ? item.medias.filter(m => m.isChoice && m.file && ['jpg', 'jpeg', 'png', 'gif'].includes(m.file.fileFormat)) : item.medias).map(m => ({ ...m.file, isChoice: m.isChoice }))
            }
          })
          this.records = records
          this.pagination = {
            page: current,
            pageSize: size,
            total,
          }
        }
        this.recordsLoading = false
      })
    },
    onPageChange(page, pageSize) {
      this.loadRecords(page, pageSize)
    },
    handleReview(recordId) {
      this.recordId = recordId
      this.showRecord = true
    },
    onDrawerClose() {
      this.showRecord = false
    },
    onRecordHandle() {
      this.showRecord = false
      this.loadRecords()
    },
    handleDel(reportId) {
      this.$confirm({
        title: '确认删除？',
        centered: true,
        onOk: () => {
          // 异步关闭
          return new Promise((resolve, reject) => {
            delReport(reportId, this.projectId).then(({ data }) => {
              if (data.success) {
                this.$message.success('操作成功')
                this.loadRecords()
                resolve()
              } else {
                this.$message.warn('操作失败')
                reject()
              }
            })
          }).catch(() => {});
        },
      })
    },
  },
  mounted() {
    this.init()
  },
}
</script>
